/**
 * @file Locale dependent postal address format definitions
 */
/**
 * @enum {string}
 * @readonly
 */
const ADDRESS_FORMATS = {
    DE: '{$name1}, {$street}, {$zip} {$city}, {$countryCode}',
    GB: '{$name1}, {$street}, {$city} {$federalState} {$zip}, {$countryCode}',
    US: '{$name1}, {$street}, {$city} {$federalState} {$zip}, {$countryCode}',
    ES: '{$name1}, {$street}, {$zip} {$city}, {$countryCode}',
    FR: '{$name1}, {$street}, {$zip} {$city}, {$countryCode}',
    IT: '{$name1}, {$street}, {$zip} {$city}, {$countryCode}',
    NL: '{$name1}, {$street}, {$zip} {$city}, {$countryCode}',
    PL: '{$name1}, {$street}, {$zip} {$city}, {$countryCode}',
    PT: '{$name1}, {$street}, {$zip} {$city}, {$countryCode}',
    DK: '{$name1}, {$street}, {$zip} {$city}, {$countryCode}'
}

export default ADDRESS_FORMATS
